import { ValidationError } from './apiError';
import { isLeft } from 'fp-ts/lib/Either';
import { RawApi } from '.';
import { golfLeaderboard, GolfLeaderboard, golfRanking, GolfRanking, GolfRankingId, GolfMatchplayLeaderboard, golfMatchPlayLeaderboard } from './validators/golf';

export interface GolfAPI {
  fetchGolfRanking: (tourId: string, rankingId: GolfRankingId) => Promise<GolfRanking>; // TODO: type
  fetchGolfLeaderboard: (tourId: string, eventId: string) => Promise<GolfLeaderboard>;
  fetchGolfMatchplayLeaderboard: (tourId: string, eventId: string) => Promise<GolfMatchplayLeaderboard>;
}

export class GolfApi extends RawApi implements GolfAPI {
  public async fetchGolfRanking(
    tourId: string,
    rankingId: GolfRankingId,
  ): Promise<GolfRanking> {
    const response = await this.fetchScoresApi(`/golf/v5/${tourId}/ranking/${rankingId}`);
    const jsonResponse: unknown = await response.json();
    const data = golfRanking.decode(jsonResponse);

    if (isLeft(data)) {
      throw new ValidationError('API Response validation failed', 400, data);
    }

    return data.right;
  }

  public async fetchGolfLeaderboard(
    tourId: string,
    eventId: string,
  ): Promise<GolfLeaderboard> {
    const response = await this.fetchScoresApi(`/golf/v5/${tourId}/leaderboard/${eventId}`);
    const jsonResponse: unknown = await response.json();
    const data = golfLeaderboard.decode(jsonResponse);

    if (isLeft(data)) {
      throw new ValidationError('API Response validation failed', 400, data);
    }

    return data.right;
  }
  public async fetchGolfMatchplayLeaderboard(
    tourId: string,
    eventId: string,
  ): Promise<GolfMatchplayLeaderboard> {
    const response = await this.fetchScoresApi(`/golf/v5/${tourId}/matches/${eventId}`);
    const jsonResponse: unknown = await response.json();
    const data = golfMatchPlayLeaderboard.decode(jsonResponse);

    if (isLeft(data)) {
      throw new ValidationError('API Response validation failed', 400, data);
    }

    return data.right;
  }
}
